import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import * as sectionBackgroundImageLeftStyles from "../../styles/landing_pages/SectionBackgroundImageLeft.module.css"

const SectionBackgroundImageLeft = props => {
  const { content } = props

  const heading = ChildSelector.select(
    content,
    `heading`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "content")
    .map(t => t.innerHTML)

  return (
    <div className={`row ${sectionBackgroundImageLeftStyles.externalWrapper} ${props.className}`}>
      <div className={`row g-0 ${sectionBackgroundImageLeftStyles.wrapper}`}>
        <div className="col-12">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div
                className={`row g-0 ${sectionBackgroundImageLeftStyles.contentWrapper}`}
              >
                <div
                  className={`col-12 col-lg-6 ${sectionBackgroundImageLeftStyles.content}`}
                >
                  <div
                    className={`${sectionBackgroundImageLeftStyles.headingWrapper}`}
                  >
                    <h1
                      className={`${sectionBackgroundImageLeftStyles.heading}`}
                    >
                      {heading}
                    </h1>
                    {textStack.map((t, idx) => (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: t,
                        }}
                        key={idx}
                      />
                    ))}
                  </div>
                  <WPCta
                    holder={content}
                    selector={`cta-btn`}
                    translate={false}
                    className={`${sectionBackgroundImageLeftStyles.ctaBtn}`}
                  />
                </div>
              </div>
            </div>
            <div
              className={`${sectionBackgroundImageLeftStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "left",
                zIndex: 1,
              }}
            >
              <WPImage
                holder={content}
                selector={`background-image`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-block ${sectionBackgroundImageLeftStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionBackgroundImageLeft
